var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{staticClass:"text-center d-flex flex-column "},[_c('v-btn',{attrs:{"color":"success"},on:{"click":_vm.delet}},[_vm._v("Удалить")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }